import React from "react";

import Modal from "../Modal";
import PixelFire from "./PixelFire";

export default class StreakSaveExplanationModal extends React.Component {
  onCloseClick() {
    this.modal.hide();
  }

  render() {
    return (
      <Modal
        id="streak-save-explanation-modal"
        ref={(el) => this.modal = el}
        size="small"
        title="Streak Saves"
        onHidden={this.props.onHidden}
      >
        <div className="text-center" style={{ padding: "8px 12px 4px" }}>
          <div style={{ marginBottom: 20, display: "flex", justifyContent: "center" }}><PixelFire size={72} /></div>
          <h3 style={{ marginTop: 0, marginBottom: 12 }}>You have {this.props.balance} Streak Save{this.props.balance === 1 ? "" : "s"}</h3>
          <p style={{ color: "#5a5a5a", marginBottom: 28 }}>
            Streak Saves protect your streak when you miss a day, even several days in a row. Every 6 days of learning earns one. You can hold up to 5.
          </p>
          <button className="btn btn-success btn-block joystix btn-lg" onClick={() => this.onCloseClick()}>
            Got it!
          </button>
        </div>
      </Modal>
    );
  }
}
